import React from 'react';
import AuthLayoutRender, {AuthProps} from './AuthLayoutRender';

export const AuthLayout = ({children}:AuthProps):JSX.Element=>{
	return <AuthLayoutRender>
		{children}
	</AuthLayoutRender>;
};